import { gql } from '@apollo/client';

/**
 * POP 不合格原因字典（详情页审核失败原因展示用，无 QC 门禁）。
 * 文案单一来源为质检枚举，随字典下发，不在前端按 code 拼 i18n。
 */
export const GET_POP_DISQUALIFY_REASON_DICT = gql`
  query GetPopDisqualifyReasonDict {
    getPopDisqualifyReasonDict {
      code
      displayOrder
      texts { lang text }
      categoryCode
      categoryTexts { lang text }
    }
  }
`;

export interface LangTextEntry {
  lang: string;
  text: string;
}

export interface PopDisqualifyReasonOption {
  code: string;
  displayOrder: number;
  texts: LangTextEntry[];
  categoryCode: string;
  categoryTexts: LangTextEntry[];
}

export interface GetPopDisqualifyReasonDictResponse {
  getPopDisqualifyReasonDict: PopDisqualifyReasonOption[];
}
